/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  //googleMapsKey: `AIzaSyAP8r76dTUNFtejkwPtBv49YmDNfO8fQPs&libraries=places&language=en`,//this is previously used key

  // googleMapsKey: `AIzaSyAziGJNZX25Y2j_KLu_QKYj9rD5IhWO-LY&libraries=places&language=en`,
  googleMapsKey: `AIzaSyAFYmrpO68uiRfTk4djAA-cvKCWlCv7-WA`,

  production: false,
  // apiUrl: "http://localhost:3300/",
  //apiUrl:"http://10.0.1.27:8081/",
  // apiUrl: "https://plspps.europassistance.in/",
  apiUrl: "https://ezauto-api.europassistance.in/",
  ssoEnable: false,
  ssoLoginUrl: "https://entrustuat.in",
  countryCode: "IN",
  country: "India",
  // host: "plspps.europassistance.in",
  host: "ezauto-api.europassistance.in",
};
